export const localizedPages = {
  "blog/index": {
    en: "/blog",
    hu: "/blog",
    cs: "/blog",
    de: "/blog",
  },
  "blog/tag/_tagSeoName": {
    en: "/blog/tag/:tagSeoName",
    hu: "/blog/cimke/:tagSeoName",
    cs: "/blog/znacka/:tagSeoName",
    de: "/blog/tag/:tagSeoName",
  },
  "blog/collection/_collectionSeoName": {
    en: "/blog/collection/:collectionSeoName",
    hu: "/blog/gyujtemeny/:collectionSeoName",
    cs: "/blog/kolekce/:collectionSeoName",
    de: "/blog/kollektion/:collectionSeoName",
  },
  "blog/profession/_professionSeoName": {
    en: "/blog/profession/:professionSeoName",
    hu: "/blog/szakma/:professionSeoName",
    cs: "/blog/profese/:professionSeoName",
    de: "/blog/beruf/:professionSeoName",
  },
  "blog/professionTask/_professionTaskSeoName": {
    en: "/blog/profession-task/:professionTaskSeoName",
    hu: "/blog/tevekenyseg/:professionTaskSeoName",
    cs: "/blog/cinnost/:professionTaskSeoName",
    de: "/blog/aktivitat/:professionTaskSeoName",
  },
  "close-tender/_personTenderId": {
    en: "/close-tender/:personTenderId",
    hu: "/ajanlatkeres-lezarasa/:personTenderId",
    cs: "/zadost-o-nabidku-zavrit/:personTenderId",
    de: "/angebot-schliessen/:personTenderId",
  },
  "blog/_articleSeoName": {
    en: "/blog/:articleSeoName",
    hu: "/blog/:articleSeoName",
    cs: "/blog/:articleSeoName",
    de: "/blog/:articleSeoName",
  },
  "request-for-tender/index": {
    en: "/request-for-tender",
    hu: "/ajanlatkeres",
    cs: "/zadost-o-nabidku",
    de: "/angebotsanfrage",
  },
  "request-for-tender/_activeTab": {
    en: "/request-for-tender/:activeTab",
    hu: "/ajanlatkeres/:activeTab",
    cs: "/zadost-o-nabidku/:activeTab",
    de: "/angebotsanfrage/:activeTab",
  },
  "request-for-tender/_activeTab/mate/_mateId": {
    en: "/request-for-tender/:activeTab/mate/:mateId",
    hu: "/ajanlatkeres/:activeTab/szaki/:mateId",
    cs: "/zadost-o-nabidku/:activeTab/profik/:mateId",
    de: "/angebotsanfrage/:activeTab/fachmann/:mateId",
  },
  "tender/_tenderId/specify/index": {
    en: "/tender/:tenderId/specify",
    hu: "/munka/:tenderId/pontositsunk",
    cs: "/prace/:tenderId/specifikace",
    de: "/angebot/:tenderId/spezifikation",
  },
  "tender/_tenderId/specify/_activeTab": {
    en: "/tender/:tenderId/specify/:activeTab",
    hu: "/munka/:tenderId/pontositsunk/:activeTab",
    cs: "/prace/:tenderId/specifikace/:activeTab",
    de: "/angebot/:tenderId/spezifikation/:activeTab",
  },
  "prices/index": {
    en: "/prices",
    hu: "/arak",
    cs: "/ceny",
    de: "/preise",
  },
  "prices/_professionTask": {
    en: "/prices/:professionTask",
    hu: "/arak/:professionTask",
    cs: "/ceny/:professionTask",
    de: "/preise/:professionTask",
  },
  "price-calculator/_professionTask/_step": {
    en: "/price-calculator/:professionTask/:step?",
    hu: "/arkalkulator/:professionTask/:step?",
    cs: "/kalkulacka-cen/:professionTask/:step?",
    de: "/preiskalkulator/:professionTask/:step?",
  },
  favorites: {
    en: "/favorites",
    hu: "/kedvencek",
    cs: "/oblibene",
    de: "/favoriten",
  },
  "profession/_professionGroup/index": {
    en: "/profession/:professionGroup",
    hu: "/szakma/:professionGroup",
    cs: "/profese/:professionGroup",
    de: "/beruf/:professionGroup",
  },
  "profession/index": {
    en: "/profession",
    hu: "/szakma",
    cs: "/profese",
    de: "/beruf",
  },
  "login/index": {
    en: "/login",
    hu: "/belepes",
    cs: "/prihlaseni",
    de: "/anmeldung",
  },
  "new-password/index": {
    en: "/new-password",
    hu: "/uj-jelszo",
    cs: "/nove-heslo",
    de: "/neues-passwort",
  },
  "professionals/_profession/index": {
    en: "/professionals/:profession",
    hu: "/szakemberek/:profession",
    cs: "/odbornici/:profession",
    de: "/fachleute/:profession",
  },
  "professionals/_profession/szakivalaszol/_questionSeoName": {
    en: "/professionals/:profession/questions/:questionSeoName",
    hu: "/szakemberek/:profession/szakivalaszol/:questionSeoName",
    cs: "/odbornici/:profession/odpovedi-odborniku/:questionSeoName",
    de: "/fachleute/:profession/fragen/:questionSeoName",
  },
  "professionals/_profession/_city/index": {
    en: "/professionals/:profession/:city",
    hu: "/szakemberek/:profession/:city",
    cs: "/odbornici/:profession/:city",
    de: "/fachleute/:profession/:city",
  },
  "career/index": {
    en: "/career",
    hu: "/karrier",
    cs: "/kariera",
    de: "/karriere",
  },
  "cities/index": {
    en: "/cities",
    hu: "/telepules",
    cs: "/mesta",
    de: "/stadte",
  },
  "counties/_county/_city/_subCity": {
    en: "/counties/:county/:city/:subCity?",
    hu: "/megyek/:county/:city/:subCity?",
    cs: "/kraje/:county/:city/:subCity?",
    de: "/bezirke/:county/:city/:subCity?",
  },
  "counties/_county/index": {
    en: "/counties/:county",
    hu: "/megyek/:county",
    cs: "/kraje/:county",
    de: "/bundeslander/:county",
  },
  "professionals/_profession/_parentCity/_city/index": {
    en: "/professionals/:profession/:parentCity/:city",
    hu: "/szakemberek/:profession/:parentCity/:city",
    cs: "/odbornici/:profession/:parentCity/:city",
    de: "/fachleute/:profession/:parentCity/:city",
  },
  "professional/_professionalSeoName/index": {
    en: "/professional/:professionalSeoName",
    hu: "/szakember/:professionalSeoName",
    cs: "/odbornik/:professionalSeoName",
    de: "/fachmann/:professionalSeoName",
  },
  "professional/_professionalSeoName/rating/index": {
    en: "/professional/:professionalSeoName/rating",
    hu: "/szakember/:professionalSeoName/ertekeles",
    cs: "/odbornik/:professionalSeoName/hodnoceni",
    de: "/fachmann/:professionalSeoName/bewertung",
  },
  "professional/_professionalSeoName/admin/person-event-log": {
    en: "/professional/:professionalSeoName/admin/person-event-log",
    hu: "/szakember/:professionalSeoName/admin/person-event-log",
    cs: "/odbornik/:professionalSeoName/admin/person-event-log",
    de: "/fachmann/:professionalSeoName/admin/person-event-log",
  },
  "professional/_professionalSeoName/admin/balance": {
    en: "/professional/:professionalSeoName/admin/balance",
    hu: "/szakember/:professionalSeoName/admin/balance",
    cs: "/odbornik/:professionalSeoName/admin/balance",
    de: "/fachmann/:professionalSeoName/admin/balance",
  },
  "professional/_professionalSeoName/admin/transfers": {
    en: "/professional/:professionalSeoName/admin/transfers",
    hu: "/szakember/:professionalSeoName/admin/transfers",
    cs: "/odbornik/:professionalSeoName/admin/transfers",
    de: "/fachmann/:professionalSeoName/admin/transfers",
  },
  "professional/_professionalSeoName/admin/merge": {
    en: "/professional/:professionalSeoName/admin/merge",
    hu: "/szakember/:professionalSeoName/admin/merge",
    cs: "/odbornik/:professionalSeoName/admin/merge",
    de: "/fachmann/:professionalSeoName/admin/merge",
  },
  "new-professionals/index": {
    en: "/new-professionals",
    hu: "/uj-szakik",
    cs: "/novi-odbornici",
    de: "/neue-fachleute",
  },
  "no-password/index": {
    en: "/no-password",
    hu: "/nincs-jelszo",
    cs: "/bez-hesla",
    de: "/kein-passwort",
  },
  registration: {
    en: "/registration",
    hu: "/regisztracio",
    cs: "/registrace",
    de: "/registrierung",
  },
  "registration/index": {
    en: "/registration/",
    hu: "/regisztracio/",
    cs: "/registrace/",
    de: "/registrierung/",
  },
  "registration/_": {
    en: "/registration/:_",
    hu: "/regisztracio/:_",
    cs: "/registrace/:_",
    de: "/registrierung/:_",
  },
  "customer-registration/index": {
    en: "/customer-registration",
    hu: "/ajanlatkeroi-regisztracio",
    cs: "/registrace-klienta",
    de: "/kundenregistrierung",
  },
  "registration/jobfeed/index": {
    en: "/registration/jobfeed",
    hu: "/regisztracio/jobfeed",
    cs: "/registrace/jobfeed",
    de: "/registrierung/jobfeed",
  },
  "registration/email/index": {
    en: "/registration/email",
    hu: "/regisztracio/email",
    cs: "/registrace/email",
    de: "/registrierung/email",
  },
  "registration/password/index": {
    en: "/registration/password",
    hu: "/regisztracio/jelszo",
    cs: "/registrace/heslo",
    de: "/registrierung/passwort",
  },
  "registration/city/index": {
    en: "/registration/city",
    hu: "/regisztracio/varos",
    cs: "/registrace/mesto",
    de: "/registrierung/stadt",
  },
  "registration/professions/index": {
    en: "/registration/professions",
    hu: "/regisztracio/szakmak",
    cs: "/registrace/profese",
    de: "/registrierung/berufe",
  },
  "registration/phone/index": {
    en: "/registration/phone",
    hu: "/regisztracio/telefonszam",
    cs: "/registrace/tel-cislo",
    de: "/registrierung/telefonnummer",
  },
  "registration/name/index": {
    en: "/registration/name",
    hu: "/regisztracio/nev",
    cs: "/registrace/jmeno",
    de: "/registrierung/name",
  },
  "registration/picture/index": {
    en: "/registration/profile-pic",
    hu: "/regisztracio/profilkep",
    cs: "/registrace/profilovka",
    de: "/registrierung/profilbild",
  },
  "registration/introduction/index": {
    en: "/registration/introduction",
    hu: "/regisztracio/bemutatkozas",
    cs: "/registrace/predstaveni",
    de: "/registrierung/vorstellung",
  },
  "registration/invoice/index": {
    en: "/registration/invoice",
    hu: "/regisztracio/szamlakepesseg",
    cs: "/registrace/fakturovani",
    de: "/registrierung/rechnung",
  },
  "registration/success/index": {
    en: "/registration/success",
    hu: "/regisztracio/siker",
    cs: "/registrace/uspech",
    de: "/registrierung/erfolg",
  },
  "inspiration/profession-task/_professionTaskSeoName": {
    en: "/inspiration/profession-task/:professionTaskSeoName",
    hu: "/inspiracio/tevekenyseg/:professionTaskSeoName",
    cs: "/inspirace/cinnost/:professionTaskSeoName",
    de: "/inspiration/aktivitat/:professionTaskSeoName",
  },
  "inspiration/profession/_professionSeoName": {
    en: "/inspiration/profession/:professionSeoName",
    hu: "/inspiracio/szakma/:professionSeoName",
    cs: "/inspirace/profese/:professionSeoName",
    de: "/inspiration/beruf/:professionSeoName",
  },
  "inspiration/index": {
    en: "/inspiration",
    hu: "/inspiracio",
    cs: "/inspirace",
    de: "/inspiration",
  },
  "inspiration/_inspirationSeoName/index": {
    en: "/inspiration/:inspirationSeoName",
    hu: "/inspiracio/:inspirationSeoName",
    cs: "/inspirace/:inspirationSeoName",
    de: "/inspiration/:inspirationSeoName",
  },
  "inspiration/_inspirationSeoName/_pictureSeoName/index": {
    en: "/inspiration/:inspirationSeoName/:pictureSeoName",
    hu: "/inspiracio/:inspirationSeoName/:pictureSeoName",
    cs: "/inspirace/:inspirationSeoName/:pictureSeoName",
    de: "/inspiration/:inspirationSeoName/:pictureSeoName",
  },
  "salaries/index": {
    en: "/salaries",
    hu: "/szakifizetesek",
    cs: "/platy",
    de: "/gehalter",
  },
  "salary-checker/index": {
    en: "/salary-checker",
    hu: "/szakifizu",
    cs: "/kalkulacka-platu",
    de: "/gehaltsrechner",
  },
  "salary-checker/average/_professionSeoName/index": {
    en: "/salary-checker/average/:professionSeoName",
    hu: "/szakifizu/atlag/:professionSeoName",
    cs: "/kalkulacka-platu/prumerny/:professionSeoName",
    de: "/gehaltsrechner/durchschnitt/:professionSeoName",
  },
  "salary-checker/average/_professionSeoName/jobs/index": {
    en: "/salary-checker/average/:professionSeoName/jobs",
    hu: "/szakifizu/atlag/:professionSeoName/munkak",
    cs: "/kalkulacka-platu/prumerny/:professionSeoName/prace",
    de: "/gehaltsrechner/durchschnitt/:professionSeoName/arbeiten",
  },
  "email-confirm/index": {
    en: "/email-confirm",
    hu: "/email-megerosites",
    cs: "/potvrzeni-emailu",
    de: "/email-bestaetigung",
  },
  "questions/index": {
    en: "/questions",
    hu: "/szakivalaszol",
    cs: "/odpovedi-odborniku",
    de: "/fragen",
  },
  "questions/profession/_professionSeoName/index": {
    en: "/questions/profession/:professionSeoName",
    hu: "/szakivalaszol/szakma/:professionSeoName",
    cs: "/odpovedi-odborniku/profese/:professionSeoName",
    de: "/fragen/beruf/:professionSeoName",
  },
  "questions/profession-task/_professionTaskSeoName/index": {
    en: "/questions/profession-task/:professionTaskSeoName",
    hu: "/szakivalaszol/tevekenyseg/:professionTaskSeoName",
    cs: "/odpovedi-odborniku/cinnost/:professionTaskSeoName",
    de: "/fragen/aktivitat/:professionTaskSeoName",
  },
  "questions/new-question/index": {
    en: "/questions/new-question",
    hu: "/szakivalaszol/uj-kerdes",
    cs: "/odpovedi-odborniku/nova-otazka",
    de: "/fragen/neue-frage",
  },
  "questions/_questionSeoName/index": {
    en: "/questions/:questionSeoName",
    hu: "/szakivalaszol/:questionSeoName",
    cs: "/odpovedi-odborniku/:questionSeoName",
    de: "/fragen/:questionSeoName",
  },
  "conductor/index": {
    en: "/conductor",
    hu: "/vezerlo",
    cs: "/conductor",
    de: "/conductor",
  },
  "conductor/blog/index": {
    en: "/conductor/blog",
    hu: "/vezerlo/blog",
    cs: "/conductor/blog",
    de: "/conductor/blog",
  },
  "conductor/blog/articles/index": {
    en: "/conductor/blog/articles",
    hu: "/vezerlo/blog/cikkek",
    cs: "/conductor/blog/clanky",
    de: "/conductor/blog/artikel",
  },
  "conductor/blog/articles/_id/index": {
    en: "/conductor/blog/articles/:id",
    hu: "/vezerlo/blog/cikkek/:id",
    cs: "/conductor/blog/clanky/:id",
    de: "/conductor/blog/artikel/:id",
  },
  "conductor/blog/articles/create/index": {
    en: "/conductor/blog/articles/create",
    hu: "/vezerlo/blog/cikkek/letrehozas",
    cs: "/conductor/blog/clanky/vytvorit",
    de: "/conductor/blog/artikel/erstellen",
  },
  "conductor/blog/collections/index": {
    en: "/conductor/blog/collections",
    hu: "/vezerlo/blog/gyujtemenyek",
    cs: "/conductor/blog/kolekce",
    de: "/conductor/blog/sammlungen",
  },
  "conductor/blog/collections/_id/index": {
    en: "/conductor/blog/collections/:id",
    hu: "/vezerlo/blog/gyujtemenyek/:id",
    cs: "/conductor/blog/kolekce/:id",
    de: "/conductor/blog/sammlungen/:id",
  },
  "conductor/blog/collections/create/index": {
    en: "/conductor/blog/collections/create",
    hu: "/vezerlo/blog/gyujtemenyek/letrehozas",
    cs: "/conductor/blog/kolekce/vytvorit",
    de: "/conductor/blog/sammlungen/erstellen",
  },
  "conductor/blog/tags/index": {
    en: "/conductor/blog/tags",
    hu: "/vezerlo/blog/cimkek",
    cs: "/conductor/blog/znacky",
    de: "/conductor/blog/tags",
  },
  "conductor/blog/tags/_id/index": {
    en: "/conductor/blog/tags/:id",
    hu: "/vezerlo/blog/cimkek/:id",
    cs: "/conductor/blog/znacky/:id",
    de: "/conductor/blog/tags/:id",
  },
  "conductor/blog/tags/create/index": {
    en: "/conductor/blog/tags/create",
    hu: "/vezerlo/blog/cimkek/letrehozas",
    cs: "/conductor/blog/znacky-vytvorit",
    de: "/conductor/blog/tags/erstellen",
  },
  "conductor/newsletter-subscriptions/index": {
    en: "/conductor/newsletter-subscriptions",
    hu: "/vezerlo/hirlevel-feliratkozasok",
    cs: "/conductor/newsletter-prihlasky",
    de: "/conductor/newsletter-abonnements",
  },
  "conductor/professions/index": {
    en: "/conductor/professions",
    hu: "/vezerlo/szakmak",
    cs: "/conductor/profese",
    de: "/conductor/berufe",
  },
  "conductor/professions/create/index": {
    en: "/conductor/professions/create",
    hu: "/vezerlo/szakmak/letrehozas",
    cs: "/conductor/profese/vytvorit",
    de: "/conductor/berufe/erstellen",
  },
  "conductor/professions/_id/index": {
    en: "/conductor/professions/:id",
    hu: "/vezerlo/szakmak/:id",
    cs: "/conductor/profese/:id",
    de: "/conductor/berufe/:id",
  },
  "conductor/profession-groups/index": {
    en: "/conductor/profession-groups",
    hu: "/vezerlo/szakmacsoportok",
    cs: "/conductor/skupiny-profesi",
    de: "/conductor/berufsgruppen",
  },
  "conductor/profession-groups/create/index": {
    en: "/conductor/profession-groups/create",
    hu: "/vezerlo/szakmacsoportok/letrehozas",
    cs: "/conductor/skupiny-profesi/vytvorit",
    de: "/conductor/berufsgruppen/erstellen",
  },
  "conductor/profession-groups/_id/index": {
    en: "/conductor/profession-groups/:id",
    hu: "/vezerlo/szakmacsoportok/:id",
    cs: "/conductor/skupiny-profesi/:id",
    de: "/conductor/berufsgruppen/:id",
  },
  "conductor/tenders/index": {
    en: "/conductor/tenders",
    hu: "/vezerlo/ajanlatkeresek",
    cs: "/conductor/zadosti-o-nabidku",
    de: "/conductor/angebotsanfragen",
  },
  "conductor/tenders/list/index": {
    en: "/conductor/tenders/list",
    hu: "/vezerlo/ajanlatkeresek/lista",
    cs: "/conductor/zadosti-o-nabidku/seznam",
    de: "/conductor/angebotsanfragen/liste",
  },
  "conductor/tenders/create/index": {
    en: "/conductor/tenders/create",
    hu: "/vezerlo/ajanlatkeresek/letrehozas",
    cs: "/conductor/zadosti-o-nabidku/vytvorit",
    de: "/conductor/angebotsanfragen/erstellen",
  },
  "conductor/tenders/_id/index": {
    en: "/conductor/tenders/:id",
    hu: "/vezerlo/ajanlatkeresek/:id",
    cs: "/conductor/zadosti-o-nabidku/:id",
    de: "/conductor/angebotsanfragen/:id",
  },
  "conductor/tenders/judge/index": {
    en: "/conductor/tenders/judge",
    hu: "/vezerlo/ajanlatkeresek/biralas",
    cs: "/conductor/zadosti-o-nabidku/posouzeni",
    de: "/conductor/angebotsanfragen/bewertung",
  },
  "conductor/persons/index": {
    en: "/conductor/persons",
    hu: "/vezerlo/felhasznalok",
    cs: "/conductor/osoby",
    de: "/conductor/personen",
  },
  "conductor/persons/_id/index": {
    en: "/conductor/persons/:id",
    hu: "/vezerlo/felhasznalok/:id",
    cs: "/conductor/osoby/:id",
    de: "/conductor/personen/:id",
  },
  "conductor/job-feeds/index": {
    en: "/conductor/job-feeds",
    hu: "/vezerlo/munkaertesitok",
  },
  "conductor/job-feeds/_id/index": {
    en: "/conductor/job-feeds/:id",
    hu: "/vezerlo/munkaertesitok/:id",
  },
  "conductor/leads/index": {
    en: "/conductor/leads",
    hu: "/vezerlo/leadek",
  },
  "conductor/leads/_id/index": {
    en: "/conductor/leads/:id",
    hu: "/vezerlo/leadek/:id",
  },
  "conductor/inspirations/index": {
    en: "/conductor/inspirations",
    hu: "/vezerlo/inspiraciok",
    cs: "/conductor/inspirace",
    de: "/conductor/inspirationen",
  },
  "conductor/inspirations/create/index": {
    en: "/conductor/inspirations/create",
    hu: "/vezerlo/inspiraciok/letrehozas",
    cs: "/conductor/inspirace/vytvorit",
    de: "/conductor/inspirationen/erstellen",
  },
  "conductor/inspirations/_id/index": {
    en: "/conductor/inspirations/:id",
    hu: "/vezerlo/inspiraciok/:id",
    cs: "/conductor/inspirace/:id",
    de: "/conductor/inspirationen/:id",
  },
  "conductor/questions/index": {
    en: "/conductor/questions",
    hu: "/vezerlo/kerdesek",
    cs: "/conductor/otazky",
    de: "/conductor/fragen",
  },
  "conductor/questions/_id/index": {
    en: "/conductor/questions/:id",
    hu: "/vezerlo/kerdesek/:id",
    cs: "/conductor/otazky/:id",
    de: "/conductor/fragen/:id",
  },
  "conductor/mini-markets/index": {
    en: "/conductor/mini-markets",
    hu: "/vezerlo/minipiacok",
  },
  "conductor/mini-markets/create/index": {
    en: "/conductor/mini-markets/create",
    hu: "/vezerlo/minipiacok/letrehozas",
  },
  "conductor/mini-markets/_id/index": {
    en: "/conductor/mini-markets/:id",
    hu: "/vezerlo/minipiacok/:id",
  },
  "conductor/zones/index": {
    en: "/conductor/profession-zones",
    hu: "/vezerlo/szakma-zonak",
  },
  "conductor/zones/positions/index": {
    en: "/conductor/profession-zones/positions",
    hu: "/vezerlo/szakma-zonak/helyezesek",
  },
  "conductor/zones/create/index": {
    en: "/conductor/profession-zones/create",
    hu: "/vezerlo/szakma-zonak/letrehozas",
  },
  "conductor/zones/_id/index": {
    en: "/conductor/profession-zones/:id",
    hu: "/vezerlo/szakma-zonak/:id",
  },
  "conductor/mini-market-teams/index": {
    en: "/conductor/mini-market-teams",
    hu: "/vezerlo/zona-csapatok",
  },
  "conductor/mini-market-teams/create/index": {
    en: "/conductor/mini-market-teams/create",
    hu: "/vezerlo/zona-csapatok/letrehozas",
  },
  "conductor/mini-market-teams/_id/index": {
    en: "/conductor/mini-market-teams/:id",
    hu: "/vezerlo/zona-csapatok/:id",
  },
  "conductor/email-templates/index": {
    en: "/conductor/email-templates",
    hu: "/vezerlo/email-sablonok",
  },
  "conductor/email-templates/create/index": {
    en: "/conductor/email-templates/create",
    hu: "/vezerlo/email-sablonok/letrehozas",
  },
  "conductor/email-templates/_id/index": {
    en: "/conductor/email-templates/:id",
    hu: "/vezerlo/email-sablonok/:id",
  },
  "conductor/ratings/index": {
    en: "/conductor/ratings",
    hu: "/vezerlo/ertekelesek",
  },
  "conductor/ratings/_id/index": {
    en: "/conductor/ratings/:id",
    hu: "/vezerlo/ertekelesek/:id",
  },
  "conductor/subcounties/index": {
    en: "/conductor/subcounties",
    hu: "/vezerlo/jarasok",
  },
  "conductor/subcounties/create/index": {
    en: "/conductor/subcounties/create",
    hu: "/vezerlo/jarasok/letrehozas",
  },
  "conductor/subcounties/_id/index": {
    en: "/conductor/subcounties/:id",
    hu: "/vezerlo/jarasok/:id",
  },
  "conductor/superadmin/index": {
    en: "/conductor/superadmin",
    hu: "/vezerlo/szuperadmin",
  },
  "conductor/service-types/index": {
    en: "/conductor/service-types",
    hu: "/vezerlo/szolgaltatastipusok",
  },
  "conductor/service-types/create/index": {
    en: "/conductor/service-types/create",
    hu: "/vezerlo/szolgaltatastipusok/letrehozas",
  },
  "conductor/service-types/_id/index": {
    en: "/conductor/service-types/:id",
    hu: "/vezerlo/szolgaltatastipusok/:id",
  },
  "my-account/jobs-in-progress/index": {
    en: "/my-account/jobs-in-progress",
    hu: "/fiokom/folyamatban-levo-munkaim",
    cs: "/muj-ucet/probihajici-prace",
    de: "/mein-konto/laufende-arbeiten",
  },
  "my-account/my-ratings/index": {
    en: "/my-account/my-ratings",
    hu: "/fiokom/ertekeleseim",
    cs: "/muj-ucet/moje-hodnoceni",
    de: "/mein-konto/meine-bewertungen",
  },
  "my-account/my-tenders/index": {
    en: "/my-account/my-tenders",
    hu: "/fiokom/ajanlatkereseim",
    cs: "/muj-ucet/moje-poptavky",
    de: "/mein-konto/meine-angebotsanfragen",
  },
  "my-account/obtainable-jobs/index": {
    en: "/my-account/obtainable-jobs",
    hu: "/fiokom/megszerezheto-munkaim",
    cs: "/muj-ucet/dostupne-prace",
    de: "/mein-konto/erhaltliche-arbeiten",
  },
  "my-account/closed-jobs/index": {
    en: "/my-account/closed-jobs",
    hu: "/fiokom/lezart-munkaim",
    cs: "/muj-ucet/uzavrene-zakazky",
    de: "/mein-konto/geschlossene-jobs",
  },
  "my-account/prices/index": {
    en: "/my-account/prices",
    hu: "/fiokom/araim",
    cs: "/muj-ucet/ceny",
    de: "/mein-konto/preise",
  },
  "my-account/references/index": {
    en: "/my-account/references",
    hu: "/fiokom/referenciaim",
    cs: "/muj-ucet/reference",
    de: "/mein-konto/referenzen",
  },
  "my-account/settings/_highlightedSetting": {
    en: "/my-account/settings/:highlightedSetting?",
    hu: "/fiokom/beallitasaim/:highlightedSetting?",
    cs: "/muj-ucet/nastaveni/:highlightedSetting?",
    de: "/mein-konto/einstellungen/:highlightedSetting?",
  },
  "my-account/subscription/index": {
    en: "/my-account/subscription",
    hu: "/fiokom/elofizetes",
    cs: "/muj-ucet/predplatne",
    de: "/mein-konto/abonnement",
  },
  "my-account/subscription/_serviceTypeSeoName/index": {
    en: "/my-account/subscription/:serviceTypeSeoName",
    hu: "/fiokom/elofizetes/:serviceTypeSeoName",
    cs: "/muj-ucet/predplatne/:serviceTypeSeoName",
    de: "/mein-konto/abonnement/:serviceTypeSeoName",
  },
  "my-account/my-job/_personTenderId": {
    en: "/my-account/my-job/:personTenderId",
    hu: "/fiokom/munkam/:personTenderId",
    cs: "/muj-ucet/moje-prace/:personTenderId",
    de: "/mein-konto/meine-arbeit/:personTenderId",
  },
  "my-account/price-offers/index": {
    en: "/my-account/price-offers",
    hu: "/fiokom/arajanlatok",
    cs: "/muj-ucet/cenove-nabidky",
    de: "/mein-konto/preisangebote",
  },
  "my-account/price-offers/_id/index": {
    en: "/my-account/price-offers/:id",
    hu: "/fiokom/arajanlatok/:id",
    cs: "/muj-ucet/cenove-nabidky/:id",
    de: "/mein-konto/preisangebote/:id",
  },
  "my-account/price-offers/new/index": {
    en: "/my-account/price-offers/new",
    hu: "/fiokom/arajanlatok/uj",
    cs: "/muj-ucet/cenove-nabidky/novy",
    de: "/mein-konto/preisangebote/neues",
  },
  "price-offer/_publicId/index": {
    en: "/price-offer/:publicId",
    hu: "/arajanlat/:publicId",
    cs: "/cena-nabidky/:publicId",
    de: "/preis-angebot/:publicId",
  },
  "static/about-us/index": {
    en: "/static/about-us",
    hu: "/static/rolunk",
    cs: "/static/o-nas",
    de: "/static/uber-uns",
  },
  "static/faq/index": {
    en: "/static/faq",
    hu: "/static/gyik",
    cs: "/static/faq",
    de: "/static/faq",
  },
  "terms/index": {
    en: "/terms",
    hu: "/aszf",
    cs: "/vop",
    de: "/agb",
  },
  "job-notification/index": {
    en: "/job-notification",
    hu: "/munkaertesito",
    cs: "/oznameni-o-praci",
    de: "/job-benachrichtigung",
  },
};

// define all pages with their respective configurations
// create class responsible for returning current page, name, eventName
